import { useCallback, useEffect, useState } from "react";

import { Row, Col, Button, DefaultSheet, SheetBody, SheetFooter } from "twyne-new.ui";

import Tool from "./Tool";

export default function DefaultDataTool({ definitions, value, onChange, onApply, onCancel, isOpen, toggle, trigger }) {
  const [open, setOpen] = useState(false)
  const [data, setData] = useState(null)

  useEffect(() => {
    if (value && !data) {
      setData(value)
    }
  }, [value, data])

  const handleToggle = useCallback(() => {
    if (toggle) {
      toggle()
    } else {
      setOpen(open => !open)
    }
  }, [toggle])

  const handleChange = useCallback(data => {
    setData(data)
    onChange && onChange(data)
  }, [onChange])

  const handleApply = useCallback(() => {
    onApply && onApply(data)
    handleToggle()
  }, [data, onApply, handleToggle])

  const handleCancel = useCallback(() => {
    onCancel && onCancel()
    handleToggle()
  }, [onCancel, handleToggle])

  return <>
    {trigger ? trigger({ onClick: () => setOpen(true) }) : null}
    <DefaultSheet
      title='Params'
      wrapperProps={{ open: open || isOpen, onOpenChange: handleToggle }}
    >
      <SheetBody>
        <Row>
          <Col size="12">
            <Tool definitions={definitions} value={data} onChange={handleChange} />
          </Col>
        </Row>
      </SheetBody>
      <SheetFooter>
        <Button color="neutral" variant="ghost" onClick={handleCancel}>Cancel</Button>
        <Button color="accent" onClick={handleApply}>Apply</Button>
      </SheetFooter>
    </DefaultSheet>
  </>
}
